var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st000{fill:none;}\r\n\t.st001{fill:#FFAA5C;}\r\n\t.st002{fill:#53C2C9;}\r\n\t.st003{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.8,
    y: 42.9,
    className: "st000",
    width: 54.2,
    height: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M452.4,16H289.2v480h163.2c20.4,0,36.9-17.6,36.9-39.3V55.3C489.3,33.6,472.8,16,452.4,16z M467,233.6h-54.2 v-46.5H467V233.6z M467,161.5h-54.2V115H467V161.5z M467,89.4h-54.2V42.9H467V89.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 285.7,
    width: 6.2,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 207.9,
    width: 6.2,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 130.1,
    width: 6.2,
    height: 32.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st002",
    d: "M399.5,258.2V16H92.7C71,16,53.4,33.6,53.4,55.3v401.3c0,21.7,17.6,39.3,39.3,39.3h335 c21.7,0,39.3-17.6,39.3-39.3V258.2H399.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 363.5,
    className: "st002",
    width: 6.2,
    height: 32.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M92.4,88.2H55.1H38.5c-8.7,0-15.8,7.1-15.8,15.8v6.9c0,8.7,7.1,15.8,15.8,15.8h16.6h37.2 c8.7,0,15.8-7.1,15.8-15.8V104C108.2,95.3,101.1,88.2,92.4,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M92.4,166H55.1H38.5c-8.7,0-15.8,7.1-15.8,15.8v6.9c0,8.7,7.1,15.8,15.8,15.8h16.6h37.2 c8.7,0,15.8-7.1,15.8-15.8v-6.9C108.2,173.1,101.1,166,92.4,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M92.4,243.8H55.1H38.5c-8.7,0-15.8,7.1-15.8,15.8v6.9c0,8.7,7.1,15.8,15.8,15.8h16.6h37.2 c8.7,0,15.8-7.1,15.8-15.8v-6.9C108.2,250.9,101.1,243.8,92.4,243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M92.4,321.6H55.1H38.5c-8.7,0-15.8,7.1-15.8,15.8v6.9c0,8.7,7.1,15.8,15.8,15.8h16.6h37.2 c8.7,0,15.8-7.1,15.8-15.8v-6.9C108.2,328.6,101.1,321.6,92.4,321.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st001",
    d: "M92.4,399.4H55.1H38.5c-8.7,0-15.8,7.1-15.8,15.8v6.9c0,8.7,7.1,15.8,15.8,15.8h16.6h37.2 c8.7,0,15.8-7.1,15.8-15.8v-6.9C108.2,406.4,101.1,399.4,92.4,399.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st003",
    d: "M393.3,337l-50.9-52.6c-0.9-1-2.5-1-3.4-0.1l-20.8,20.1c-1,0.9-1,2.4-0.1,3.4l0.5,0.5 c-16,0.4-46.9-16.3-66.2-35.9c-19-19.9-34.7-51.3-33.7-67.3l0.5,0.5c0.9,1,2.5,1,3.4,0.1l20.8-20.1c1-0.9,1-2.5,0.1-3.4l-50.9-52.6 c-0.9-1-2.5-1-3.4-0.1l-20.8,20.1c-0.9,0.9-1,2.4-0.1,3.4l0,0c-10.7,13.9-13.1,28.9-6.5,49.1c3.3,10.1,17,47.2,64.1,96.1 c47.3,48.6,84,63.6,93.9,67.2c20,7.2,35.1,5.3,49.3-4.9l0,0c0.9,0.9,2.4,1,3.4,0.1l20.8-20.2C394.2,339.5,394.3,338,393.3,337z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLog);
export default __webpack_public_path__ + "static/media/call-log.0e70d74be1701bb221e2f2477135c963.svg";
export { ForwardRef as ReactComponent };